import AccountCard from "../shared/AccountCard";
import Pill from "../shared/Pill";
import { fmt } from "../../data/mockData";
import { useIsMobile } from "../../hooks/useIsMobile";

export default function AccountsPage({ accounts, filter, onFilterChange, totalAssets, totalDebt, netWorth }) {
  const isMobile = useIsMobile();
  const filters = ["all", "checking", "savings", "credit", "investment", "debt"];

  return (
    <div>
      {/* Filter Pills */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "24px", flexWrap: "wrap" }}>
        {filters.map(f => (
          <Pill key={f} active={filter === f} onClick={() => onFilterChange(f)}>
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </Pill>
        ))}
      </div>

      {/* Account Cards Grid */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: "16px" }}>
        {accounts.map((a, i) => (
          <div key={a.id} className="card-anim" style={{ animationDelay: `${i * 0.05}s` }}>
            <AccountCard account={a} />
          </div>
        ))}
      </div>

      {/* Summary Row */}
      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr", gap: "16px", marginTop: "24px" }}>
        {[
          { label: "Total Assets", value: totalAssets,         color: "#52D68A" },
          { label: "Total Debt",   value: Math.abs(totalDebt), color: "#F87171" },
          { label: "Net Worth",    value: netWorth,             color: "#D4AF37" },
        ].map(s => (
          <div key={s.label} style={{ background: "var(--bg-surface)", border: "1px solid var(--border)", borderRadius: "14px", padding: "20px" }}>
            <div style={{ fontSize: "11px", color: "var(--text-secondary)", fontFamily: "'JetBrains Mono', monospace", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "8px" }}>{s.label}</div>
            <div style={{ fontSize: "30px", fontFamily: "'Capsule Sans', sans-serif", fontWeight: "700", color: s.color }}>{fmt(s.value)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
